module.exports = __webpack_public_path__ + "img/iWay-logo-white.0f8cef3c.svg";